// Stellt die aktuelle boardId tief im Render-Baum bereit (z.B. fuer den Image-Renderer,
// der presignte Asset-URLs board-scoped holen muss).

import { createContext, useContext } from "react";

export const BoardIdContext = createContext<string | null>(null);

export function useBoardId(): string | null {
  return useContext(BoardIdContext);
}
